import ISettingsPopupSelectField from "./SettingsPopupSelectField.interface";
import SelectField from "../../../../../components/SelectField";
import { IOption } from "../../../../../components/SelectField/SelectField.interface";
import cn from 'classnames';
import styles from "./SettingsPopupSelectField.module.css";

const SettingsPopupSelectField = ({ label, options, selectedValue, setSelectedValue }: ISettingsPopupSelectField) => {
  const selectedOptionHandler = ({value}: IOption) => {
    setSelectedValue(value);
  };
  return (
    <>
      <div className={cn(styles['settings-popup-select-field__label'])}>
        {label}
      </div>
      <div className={cn(styles['settings-popup-select-field__select-field'])}>
        <SelectField
          placeholder={options[0] ? "Устройство по умолчанию" : "Нет доступных устройств"}
          selectedOption={selectedValue}
          selectedOptionHandler={(option) => selectedOptionHandler(option)}
          value={selectedValue.label}
          options={options.map(({label, value}) => ({
            value,
            label,
          }))}
        />
      </div>
    </>
  );
};

export default SettingsPopupSelectField;